import { render, staticRenderFns } from "./ad-rating.vue?vue&type=template&id=968eb5f8&lang=html"
import script from "./ad-rating.vue?vue&type=script&lang=js"
export * from "./ad-rating.vue?vue&type=script&lang=js"
import style0 from "./ad-rating.vue?vue&type=style&index=0&id=968eb5f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports